import { apiClient } from '@/shared/lib/apiClient';
import type { ApiSuccessResponse } from '@super-admin/shared-types';
import type { PortalSubscriptionPlansResponse } from '../types/portalPlans';

export async function fetchPortalSubscriptionPlans(): Promise<PortalSubscriptionPlansResponse> {
  const res = await apiClient.get<ApiSuccessResponse<PortalSubscriptionPlansResponse>>(
    '/api/v1/customer/subscription/plans',
  );
  return res.data;
}
